export const topics = [
  {
    id: "small-things-that-made-you-laugh",
    title: "今日话题：今天有没有哪件小事，让你偷偷笑出了声？",
    excerpt:
      "早上在电梯里，一只柯基主动把屁股挪到我脚边蹭了蹭，那一刻整层楼的疲惫都被治愈了。今天想收集大家的快乐碎片。",
    board: "today",
    boardName: "今日话题",
    author: "瓜田值班阿禾",
    authorTag: "值班版主",
    createdAt: "今天 09:12",
    replies: 316,
    views: 24800,
    likes: 1860,
    tags: ["今日话题", "快乐碎片", "互动"],
    cover: "https://readdy.ai/api/search-image?query=Bright%20cheerful%20young%20people%20laughing%20together%20in%20a%20sunny%20warm%20cafe%2C%20soft%20natural%20light%2C%20cozy%20friendly%20community%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20warm%20green%20and%20cream%20tones&width=1200&height=800&seq=gt-topic-01&orientation=landscape",
    isHot: true,
    content: [
      "早上赶着上班，在电梯里一只柯基突然主动把屁股挪到我脚边蹭了蹭，还回头看了我一眼。那一刻整层楼的疲惫都被治愈了，我憋着笑一直到出电梯才乐出来。",
      "所以今天想开一个话题：你有没有遇到过那种特别小、特别不起眼，却能让你偷偷笑出声的瞬间？可以是一件傻事，也可以是一句别人的口误，甚至是你自己脑补出来的画面。",
      "我会挑几条特别好的放在楼层置顶。作为交换，我先分享第二件：昨天点外卖备注「不要葱」，店家在袋子上回了我一句「好的，一根葱都不放」。就这一句话，我笑了一整个下午。",
    ],
    replyList: [
      {
        author: "楼下的猫",
        authorTag: "活跃瓜友",
        time: "今天 09:26",
        content:
          "我家狗子每次听到「遛弯」都会假装犯困，然后偷偷瞄我有没有去拿牵引绳，演技差到让人心疼又好笑。",
        likes: 208,
      },
      {
        author: "一杯温豆浆",
        authorTag: "瓜田常客",
        time: "今天 09:41",
        content:
          "排队的姑娘对着手机说「好的妈妈」，然后挂断电话小声嘀咕「明明是我男朋友」。我站在后面差点没忍住。",
        likes: 156,
      },
      {
        author: "晚风半糖",
        authorTag: "新来的瓜",
        time: "今天 10:03",
        content:
          "楼主的柯基太可爱了！我今天的快乐是发现咖啡杯上写错的名字，愣是把我的名字写成了「微辣」。",
        likes: 97,
      },
      {
        author: "阿禾本人",
        authorTag: "值班版主",
        time: "今天 10:20",
        content:
          "楼上「微辣」那个我先笑为敬。快乐碎片已经收了一百多条，晚点整理成合集发在新帖里，记得来看！",
        likes: 132,
      },
    ],
  },
  {
    id: "before-you-jump-to-conclusions",
    title: "热搜又刷屏了，先别急着下结论，聊聊怎么理性吃瓜",
    excerpt:
      "每次热搜一来，评论区三分钟就能分成两队。分享几个我自己用的「慢半拍」方法，也欢迎补充，毕竟吃瓜是为了放松，不是为了上火。",
    board: "gossip",
    boardName: "吃瓜第一线",
    author: "慢炖一锅瓜",
    authorTag: "资深瓜友",
    createdAt: "今天 08:40",
    replies: 254,
    views: 31200,
    likes: 2410,
    tags: ["热帖推荐", "理性讨论", "吃瓜第一线"],
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20floating%20speech%20bubbles%20and%20magnifying%20glass%20over%20a%20calm%20green%20field%2C%20modern%20editorial%20graphic%20style%2C%20warm%20cream%20background%2C%20thoughtful%20rational%20tone&width=1200&height=800&seq=gt-topic-02&orientation=landscape",
    isHot: true,
    content: [
      "这两天热搜换得比天气还快，评论区常常三分钟就分成两队，越聊越上头，最后谁也没记住到底发生了什么。我自己总结了几个「慢半拍」的习惯，分享给大家。",
      "第一，先看信息源。是当事人说的、媒体转述的，还是评论区听来的？把这三类分清，情绪立刻能降一半。第二，把「我讨厌这个人」和「这件事他做得对不对」分开，很多时候我们反对的其实是前者。",
      "第三，允许自己不知道结论。不是每件事都要站队，说一句「我再看看」并不是怂。吃瓜本来是为了放松，如果聊完更上火，那这瓜就吃得不值了。",
      "欢迎在回帖里补充你的方法，也欢迎温和地反驳我。这个版块的目标很简单：先摆事实，再聊感受，理性吃瓜不站队。",
    ],
    replyList: [
      {
        author: "冷静的西瓜刀",
        authorTag: "资深瓜友",
        time: "今天 08:55",
        content:
          "补充一条：别在气头上打字。我现在养成习惯，情绪上来了先存草稿，过十分钟再看，八成的帖子我都会删掉。",
        likes: 312,
      },
      {
        author: "青柠不加冰",
        authorTag: "瓜田常客",
        time: "今天 09:18",
        content:
          "「允许自己不知道结论」这句说得太好了。好多争论其实是因为大家都想立刻要一个答案。",
        likes: 187,
      },
      {
        author: "小满同学",
        authorTag: "新来的瓜",
        time: "今天 09:47",
        content: "刚来这个版，看到大家的回帖氛围真的很舒服，以前在其他地方都不敢说话。",
        likes: 94,
      },
    ],
  },
  {
    id: "tiny-forest-in-rental",
    title: "在出租屋里养出一片小森林，总共花了不到三百块",
    excerpt:
      "房子是租的，但日子是自己的。分享一下我这两个月低成本布置绿植角落的全部清单和踩坑记录，新手友好。",
    board: "life",
    boardName: "生活茶话会",
    author: "阳台种豆人",
    authorTag: "生活达人",
    createdAt: "昨天 21:05",
    replies: 178,
    views: 18600,
    likes: 1520,
    tags: ["生活茶话会", "绿植", "出租屋改造"],
    cover: "https://readdy.ai/api/search-image?query=Cozy%20small%20rental%20apartment%20corner%20filled%20with%20lush%20green%20houseplants%20near%20a%20sunny%20window%2C%20warm%20natural%20light%2C%20simple%20wooden%20stool%2C%20calm%20minimal%20lifestyle%20photography%2C%20soft%20cream%20and%20green%20tones&width=1200&height=800&seq=gt-topic-03&orientation=landscape",
    isHot: false,
    content: [
      "搬进这个不到二十平的出租屋时，我最受不了的就是那面白得发空的墙角。房东不让打孔，我就试着用最便宜的方式给它加点绿。",
      "最后成品是一面「阶梯绿植角」：一个二手木质置物架 90 块，六盆耐阴植物加起来不到一百二，剩下的是花盆和托盘。耐阴真的是新手救命选项，绿萝、虎皮兰、龟背竹几乎不用管。",
      "踩坑记录也写上：第一，别一上来就买需要充足直射光的植物，北向房间会养一盆死一盆；第二，托盘一定要买，不然每次浇水都在和楼下的邻居赌运气；第三，别囤土，用多少买多少，剩下的只会招小飞虫。",
      "现在每天早上下楼前，我都会在角落站三十秒，看看有没有新叶子。房子是租的，但心情是自己的。",
    ],
    replyList: [
      {
        author: "南窗有风",
        authorTag: "瓜田常客",
        time: "昨天 21:33",
        content: "求那个置物架的链接！我家的角落也空着好久了，一直不知道从哪下手。",
        likes: 142,
      },
      {
        author: "会呼吸的绿",
        authorTag: "生活达人",
        time: "昨天 22:10",
        content:
          "龟背竹真的新手之光。我去年买的，现在长得比我还高，唯一的缺点就是占地方。",
        likes: 88,
      },
      {
        author: "阳台种豆人",
        authorTag: "生活达人",
        time: "昨天 22:41",
        content:
          "补充一个防小飞虫的小技巧：土表面铺一层陶粒，浇水不容易冲散，也基本不招虫。",
        likes: 116,
      },
    ],
  },
  {
    id: "reporting-skill-matters",
    title: "入职三个月才明白：汇报做得好，不如把话说明白",
    excerpt:
      "以前我总觉得汇报是「表演」，直到被领导一句话点醒——他不是要听我多努力，而是想知道「现在什么情况、要他做什么决定」。",
    board: "work",
    boardName: "职场唠嗑",
    author: "周一不emo",
    authorTag: "职场老瓜",
    createdAt: "昨天 19:20",
    replies: 205,
    views: 22400,
    likes: 1980,
    tags: ["职场唠嗑", "沟通", "新人成长"],
    cover: "https://readdy.ai/api/search-image?query=Calm%20minimal%20modern%20desk%20with%20open%20notebook%20and%20laptop%2C%20soft%20morning%20light%2C%20uncluttered%20professional%20workspace%2C%20editorial%20photography%2C%20warm%20neutral%20and%20muted%20green%20tones&width=1200&height=800&seq=gt-topic-04&orientation=landscape",
    isHot: false,
    content: [
      "刚入职那阵子，我特别怕周会。每次都准备了满满一页内容，从背景讲到细节，讲完自己挺感动，领导的眉头却越皱越紧。",
      "直到有次他打断我，说了句很朴素的话：「你只要告诉我三件事——现在什么情况、卡在哪、需要我做什么决定。」那一刻我才反应过来，汇报不是表演努力，而是帮对方节省判断成本。",
      "后来我把结构固定成三段：一，结论先行，一句话讲清现状；二，关键事实，只留影响决策的两三条；三，需要支持，明确到人和时间。神奇的是，准备时间反而更短了，因为大部分细节本来就不需要讲。",
      "写出来给同样在职场里摸索的瓜友参考。如果你也有类似被点醒的瞬间，欢迎在回帖里聊聊。",
    ],
    replyList: [
      {
        author: "摸鱼也要优雅",
        authorTag: "瓜田常客",
        time: "昨天 19:52",
        content: "结论先行这条真的能救命。我以前喜欢铺垫，领导听两句就开始看手机了。",
        likes: 176,
      },
      {
        author: "打工人小周",
        authorTag: "新来的瓜",
        time: "昨天 20:30",
        content: "请问「需要支持」这part，新人直接提要求会不会显得不懂事啊？",
        likes: 63,
      },
      {
        author: "周一不emo",
        authorTag: "职场老瓜",
        time: "昨天 20:45",
        content:
          "回楼上：说清楚「我需要谁、在什么时候、帮你确认什么」，这不是提要求，是把选择权交给对方，反而更专业。",
        likes: 154,
      },
    ],
  },
  {
    id: "ensemble-drama-sidekicks",
    title: "最近这部群像剧，配角的魅力比主线还让人上头",
    excerpt:
      "主线还在慢慢推，我却被几个配角圈得死死的。不剧透，只聊人物塑造，欢迎一起讨论你心里的最佳配角。",
    board: "screen",
    boardName: "影视追剧社",
    author: "爆米花加倍",
    authorTag: "追剧党",
    createdAt: "前天 22:15",
    replies: 189,
    views: 20100,
    likes: 1360,
    tags: ["影视追剧社", "群像剧", "人物讨论"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20empty%20theater%20seats%20with%20soft%20warm%20lighting%20and%20glowing%20screen%20reflection%2C%20artistic%20film%20photography%2C%20rich%20cream%20and%20deep%20green%20tones%2C%20no%20text&width=1200&height=800&seq=gt-topic-05&orientation=landscape",
    isHot: false,
    content: [
      "这部剧的主线推进得不算快，但配角的塑造是真的下了功夫。每个人都带着自己的小心思，没有纯粹的「工具人」，哪怕只出场两三场戏，你也能记住他为什么这么做。",
      "我特别喜欢其中一个面冷心热的角色，编剧没有用大段台词去解释他的温柔，而是让他默默做了一件很小的事。那种「不点破」的处理，比反复强调人设高级太多。",
      "本篇承诺零剧透，只聊人物和表演。你心里的最佳配角是谁？理由是哪一个瞬间打动了你？评论区见。",
    ],
    replyList: [
      {
        author: "深夜看剧人",
        authorTag: "追剧党",
        time: "前天 22:48",
        content: "盲猜你说的是那场雨戏里递伞的镜头，我看到的时候真的眼眶一热。",
        likes: 121,
      },
      {
        author: "一颗红枣",
        authorTag: "瓜田常客",
        time: "前天 23:20",
        content: "群像剧最好的地方就是没有唯一主角，每个人都在过自己的日子。",
        likes: 87,
      },
      {
        author: "爆米花加倍",
        authorTag: "追剧党",
        time: "前天 23:55",
        content: "楼上说得对，生活本来就没有主角视角，这可能就是它耐看的原因吧。",
        likes: 74,
      },
    ],
  },
  {
    id: "bullet-journal-half-year",
    title: "从零学做手账半年，我意外戒掉了睡前刷手机",
    excerpt:
      "本来只是想找个爱好，没想到一本手账把我的晚上重新还给了自己。分享入门装备和三个最容易坚持的技巧。",
    board: "hobby",
    boardName: "兴趣同好圈",
    author: "胶带收藏家",
    authorTag: "手账同好",
    createdAt: "前天 20:30",
    replies: 143,
    views: 15800,
    likes: 1120,
    tags: ["兴趣同好圈", "手账", "习惯养成"],
    cover: "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20an%20open%20bullet%20journal%20with%20washi%20tape%2C%20colored%20pens%20and%20dried%20flowers%20on%20a%20warm%20cream%20desk%2C%20soft%20daylight%2C%20cozy%20craft%20lifestyle%20photography%2C%20warm%20green%20and%20beige%20palette&width=1200&height=800&seq=gt-topic-06&orientation=landscape",
    isHot: false,
    content: [
      "半年前我开始做手账，理由特别朴素：想找一件不费眼睛、又能让我安静下来的事。结果做着做着，睡得越来越早，睡前刷手机的习惯也慢慢没了。",
      "入门装备其实不用多：一本普通方格本、两支顺手的笔、一卷喜欢的胶带，总共不到五十块。真正让我坚持下来的，是三个小技巧。",
      "第一，不追求好看，只追求记下来。一开始就想着排版，多半第三页就弃坑了。第二，一次只写三行，写不满也没关系，别给自己留作业。第三，把它放在床头，想刷手机时手够得到本子。",
      "现在晚上十点半，我会关掉手机写十分钟，把当天最想留下的一件事画下来。这个习惯带给我的放松感，比刷一晚上短视频强太多了。",
    ],
    replyList: [
      {
        author: "慢慢记录",
        authorTag: "手账同好",
        time: "前天 21:00",
        content: "「不追求好看，只追求记下来」这句话点醒我了，我去年就是被排版劝退的。",
        likes: 165,
      },
      {
        author: "小铅笔头",
        authorTag: "新来的瓜",
        time: "前天 21:40",
        content: "请问新手直接用方格本可以吗，还是要买专门的手账本？",
        likes: 52,
      },
      {
        author: "胶带收藏家",
        authorTag: "手账同好",
        time: "前天 22:05",
        content: "回楼上：方格本完全够用，等确定真的喜欢再升级，不然又是一笔冲动消费。",
        likes: 98,
      },
    ],
  },
  {
    id: "friendship-drifted-apart",
    title: "和好朋友渐渐走远，要不要主动去挽回？",
    excerpt:
      "没有吵架，没有矛盾，只是聊天越来越少，从每天都聊到几个月一句。想听听大家的经历，也想给自己一点勇气。",
    board: "heart",
    boardName: "情感树洞",
    author: "匿名的橘子",
    authorTag: "树洞常客",
    createdAt: "前天 18:10",
    replies: 268,
    views: 27600,
    likes: 2040,
    tags: ["情感树洞", "友情", "树洞"],
    cover: "https://readdy.ai/api/search-image?query=Quiet%20soft%20abstract%20scene%20of%20two%20empty%20wooden%20chairs%20facing%20a%20misty%20green%20garden%2C%20gentle%20warm%20morning%20light%2C%20melancholic%20calm%20mood%2C%20artistic%20photography%2C%20muted%20cream%20and%20sage%20tones&width=1200&height=800&seq=gt-topic-07&orientation=landscape",
    isHot: true,
    content: [
      "我们认识七年了，从大学一起熬夜到工作后互相吐槽。可这两个月，聊天记录停在她回的一个「嗯」，之后再没接上。",
      "没有吵架，也没有谁对不起谁，只是各自的生活越来越满，话题慢慢变少。我点开对话框好几次，打好一句话又删掉，怕显得刻意，也怕对方其实已经不在意了。",
      "我知道成年人的关系会自然淡掉，可还是有点不甘心。有没有经历过类似情况的瓜友？如果是你，会主动开口吗？还是就这样让它慢慢过去？",
      "把这里当成一个可以放心说话的地方，谢谢每一个认真回帖的人。",
    ],
    replyList: [
      {
        author: "温柔的刺猬",
        authorTag: "树洞常客",
        time: "前天 18:35",
        content:
          "我主动过。发了一句「最近看到一个东西特别像你」，然后就聊起来了。别小看这种没负担的开场，比「我们聊聊吧」轻松太多。",
        likes: 326,
      },
      {
        author: "路过的向日葵",
        authorTag: "瓜田常客",
        time: "前天 19:02",
        content:
          "也有人说友情不用挽留，但我觉得想联系就去联系，至少不给自己留遗憾，剩下的交给对方。",
        likes: 198,
      },
      {
        author: "匿名的橘子",
        authorTag: "树洞常客",
        time: "前天 19:30",
        content: "谢谢你们。我刚刚把一句话发了出去，心跳很快，但好像轻松了一点。",
        likes: 412,
      },
    ],
  },
  {
    id: "workday-bento-formula",
    title: "一周工作日便当挑战，我总结了 5 个万能公式",
    excerpt:
      "连续五天带饭不重样，成本比外卖省一半。附上采购清单和做饭时间安排，早起十五分钟就能搞定。",
    board: "food",
    boardName: "美食瓜田",
    author: "厨房小白进化中",
    authorTag: "美食瓜友",
    createdAt: "3 天前 12:20",
    replies: 196,
    views: 19200,
    likes: 1680,
    tags: ["美食瓜田", "便当", "省钱"],
    cover: "https://readdy.ai/api/search-image?query=Neat%20homemade%20lunch%20bento%20boxes%20with%20rice%2C%20vegetables%20and%20eggs%20arranged%20in%20a%20row%20on%20a%20warm%20wooden%20table%2C%20soft%20daylight%2C%20appetizing%20food%20photography%2C%20warm%20green%20and%20cream%20color%20palette&width=1200&height=800&seq=gt-topic-08&orientation=landscape",
    isHot: false,
    content: [
      "同事都在点外卖的时候，我坚持带了一周饭。最大的感受不是省钱，而是中午不用纠结吃什么，整个人都松弛了。",
      "五个公式分享给大家：一，一主食一荤两素，颜色凑够三种；二，周末一次性处理蔬菜，切好分装冷冻；三，肉类用腌料提前一晚上腌制，第二天直接下锅；四，主食留一份杂粮，饱腹感更久；五，带一个独立的小菜盒装凉拌菜，中午口感不塌。",
      "时间安排也很简单：早上起来先热主食，同时炒一个菜，最后装盒，十五分钟足够。真算下来，一天成本大概十五块，比外卖省了一半还多。",
      "有需要的瓜友可以在回帖里说一声，我把采购清单整理成图发上来。",
    ],
    replyList: [
      {
        author: "干饭第一名",
        authorTag: "美食瓜友",
        time: "3 天前 13:05",
        content: "求采购清单！我每次买菜都是想着做便当，最后全放坏了。",
        likes: 138,
      },
      {
        author: "米饭杀手",
        authorTag: "瓜田常客",
        time: "3 天前 13:40",
        content:
          "冷冻预处理真的有用，我周日花一小时，接下来一整周都轻松，强烈推荐给上班族。",
        likes: 102,
      },
      {
        author: "厨房小白进化中",
        authorTag: "美食瓜友",
        time: "3 天前 14:12",
        content: "楼上说到重点了，一人食最怕的不是难吃，是浪费，所以量一定要控制好。",
        likes: 85,
      },
    ],
  },
  {
    id: "what-would-you-do-with-free-wednesday",
    title: "如果给你一个不用上班的周三，你会怎么过？",
    excerpt:
      "新话题来了：不是周末，是平平无奇的周三突然放假一天。你会补觉、出门、还是把攒了很久的事做掉？",
    board: "today",
    boardName: "今日话题",
    author: "瓜田值班阿禾",
    authorTag: "值班版主",
    createdAt: "3 天前 09:00",
    replies: 342,
    views: 26800,
    likes: 1590,
    tags: ["今日话题", "互动", "大家一起聊"],
    cover: "https://readdy.ai/api/search-image?query=Sunny%20quiet%20city%20park%20bench%20with%20green%20trees%20and%20a%20coffee%20cup%2C%20empty%20and%20peaceful%20midweek%20afternoon%2C%20soft%20golden%20light%2C%20lifestyle%20photography%2C%20warm%20green%20and%20cream%20tones&width=1200&height=800&seq=gt-topic-09&orientation=landscape",
    isHot: true,
    content: [
      "这周的今日话题有点「奢侈」：假设周一通知你，周三全体放假一天，工资照发，也不用补班。你会怎么安排这凭空多出来的一天？",
      "是睡到自然醒，把欠了很久的觉一次补齐？还是趁着工作日景区人少，来一场说走就走的小出行？又或者，你早就有一件拖了很久的事，正好用这一天清掉？",
      "我先说我的：上午去公园看别人遛狗，中午吃一顿平时舍不得的工作日午餐，下午把囤了三个月的书翻开。听起来很普通，但光是想想就已经很治愈了。",
      "欢迎在回帖里写下你的安排，也欢迎@那个你最想一起过这一天的人。",
    ],
    replyList: [
      {
        author: "睡到自然醒",
        authorTag: "瓜田常客",
        time: "3 天前 09:22",
        content: "什么都不做，就在家躺着。成年人的奢侈不是出去玩，是可以名正言顺地发呆一整天。",
        likes: 289,
      },
      {
        author: "想去看海",
        authorTag: "新来的瓜",
        time: "3 天前 09:50",
        content: "我会坐最早一班车去海边，工作日人少，光这一点就值回票价了。",
        likes: 176,
      },
      {
        author: "瓜田值班阿禾",
        authorTag: "值班版主",
        time: "3 天前 10:15",
        content:
          "目前「睡到自然醒」票数领先。看来大家缺的其实不是时间，是一段可以被允许的空白。",
        likes: 231,
      },
    ],
  },
  {
    id: "moved-near-office-regret",
    title: "为了省通勤搬到公司附近，我后悔了吗？半年后的真实答案",
    excerpt:
      "通勤从两小时变成十分钟，房租贵了八百。很多人问我值不值，这篇把账算清楚，也把代价说清楚。",
    board: "life",
    boardName: "生活茶话会",
    author: "十分钟到岗",
    authorTag: "生活达人",
    createdAt: "4 天前 20:45",
    replies: 221,
    views: 23400,
    likes: 1730,
    tags: ["生活茶话会", "通勤", "搬家"],
    cover: "https://readdy.ai/api/search-image?query=Charming%20narrow%20city%20street%20in%20early%20morning%20with%20warm%20sunlight%20and%20green%20street%20trees%20near%20small%20apartment%20buildings%2C%20calm%20everyday%20scene%2C%20warm%20cream%20and%20green%20tones&width=1200&height=800&seq=gt-topic-10&orientation=landscape",
    isHot: false,
    content: [
      "搬家前，我每天通勤单程一小时，来回两个多小时。地铁上永远没座位，到家只想瘫着。撑了一年半之后，我下定决心搬到公司附近。",
      "房租从一千八变成两千六，多出来的八百，我一度很心疼。但半年下来，我把变化记了下来：每天多出两小时可自由支配，早饭能好好吃，晚上不再因为怕第二天起不来而焦虑。",
      "当然也有代价：公司附近吃饭贵，周末想找朋友得跨半座城，房租压力确实更大了。所以「值不值」其实没有标准答案，取决于那两小时你打算用来做什么。",
      "如果你的通勤也超过一个半小时，可以对照看看。有任何关于搬家和通勤的疑问，都欢迎在回帖里问我。",
    ],
    replyList: [
      {
        author: "地铁常驻居民",
        authorTag: "瓜田常客",
        time: "4 天前 21:10",
        content:
          "我通勤单程一小时二十分钟，看完纠结了。请问你多出来的时间真的用起来了吗，还是也在刷手机？",
        likes: 158,
      },
      {
        author: "十分钟到岗",
        authorTag: "生活达人",
        time: "4 天前 21:35",
        content:
          "回楼上：前一个月确实在刷手机，后来逼自己固定去楼下散步加看书，才算真的用起来了。",
        likes: 132,
      },
      {
        author: "慢慢来比较好",
        authorTag: "新来的瓜",
        time: "4 天前 22:02",
        content: "「两小时你打算用来做什么」这句问得好扎心，我可能真的会拿它换睡眠。",
        likes: 97,
      },
    ],
  },
];